import { clientFetch } from 'utils/client-fetch';

export async function graphqlQuery<T>(baseUrl: string, query: string): Promise<T> {
    const response = await clientFetch({
        method: 'post',
        url: `${baseUrl}/graphql`,
        body: { query }
    });
    if (!('data' in response) || !response.data) {
        console.error(response.errors);
        throw new Error('Errors in GraphQL query');
    }
    return Object.entries(response.data)[0][1] as T;
}
